import { useQuery } from '@tanstack/react-query'

import {
  listProfessionalMedicalRequests,
  Validity,
} from 'services/professionals/listProfessionalMedicalRequests'

interface useProfessionalMedicalRequestsType {
  validities: Validity[];
  pagination: {
    page: number;
    pages: number;
    per_page: number;
    total: number;
  };
  isLoading: boolean;
  isSuccess: boolean;
}

export const PROFESSIONAL_MEDICAL_REQUEST_QUERY_KEY = 'PROFESSIONAL_MEDICAL_REQUESTS'

export const useProfessionalMedicalRequests = (fetchValidities: boolean): useProfessionalMedicalRequestsType => {
  const { data, isSuccess, isLoading } = useQuery({
    queryKey: [PROFESSIONAL_MEDICAL_REQUEST_QUERY_KEY],
    queryFn: () => listProfessionalMedicalRequests({}),
    enabled: fetchValidities,
    staleTime: 10 * (60 * 1000), // 10 mins 
    cacheTime: 15 * (60 * 1000), // 15 mins 
  })

  return {
    validities: data?.person_profile_plan_treatment_validities,
    pagination: data?.pagination,
    isLoading,
    isSuccess,
  }
}